module.exports = __webpack_public_path__ + "static/media/1350_Cart_Medical_editPopup.75448af3.png";